"use strict";
/**
 * JSON-RPC 2.0 Specification
 * http://www.jsonrpc.org/specification
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=json-rpc.type.js.map